// ======================================================================
// File Name       : ContentVideoSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button, Row } from 'react-bootstrap';
import SelectBox from '../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import PaginationCustom from '../Pagination';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import DateTimeWithValidate from '../../components/DateTimeWithValidate';
import DateTimeMinMax from '../../components/DateTimeMinMax';
import CustomButton from '../button/CustomButton';
import CustomLink from '../button/CustomLink';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import * as FUNCTION from '../../constants/FunctionConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';

class ContentVideoSearch extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      contentSecernId,
      contentName,
      videoStatus,
      createdDateFrom,
      createdDateTo,
      dataAffiliationType,
      videoSortType,
      ascendingDescendingSort,
      getStartEndData,
      startPosition,
      recordNum,
      returnMaxNum,
      handleChange,
      handlePublicTimeChange,
      onSearchBtnClick,
      onExportBtnClick,
      createdUserName, // Step 9.0.0
    } = this.props;
    this.refsToValidate = [];
    const canAccessImport = canAccessRoute(FUNCTION.CONTENT_VIDEO_IMPORT);
    const canAccessRegister = canAccessRoute(FUNCTION.CONTENT_VIDEO_REGISTER);

    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Form onSubmit={(e) => {e.preventDefault(); onSearchBtnClick();}} className='form-horizontal'>
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ識別ID
              </Col>
              <Col sm={7}>
                <FormControl
                  type="text"
                  name="contentSecernId"
                  value={contentSecernId}
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ名
              </Col>
              <Col sm={7}>
                <FormControl
                  type="text"
                  name="contentName"
                  value={contentName}
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                変換ステータス
              </Col>
              <Col sm={7}>
                <SelectBox
                  data={SELECT_BOX_DATA.VIDEO_STATUS}
                  name="videoStatus"
                  value={videoStatus}
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                登録日
              </Col>
              <Col sm={3}>
                <DateTimeWithValidate
                  onChange={dateString => handlePublicTimeChange('createdDateFrom', dateString)}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  value={createdDateFrom || ''}
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <DateTimeWithValidate
                  onChange={dateString => handlePublicTimeChange('createdDateTo', dateString)}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  value={createdDateTo || ''}
                />
              </Col>
              <Col sm={12}>
                <DateTimeMinMax
                  dateFrom={createdDateFrom}
                  dateTo={createdDateTo}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Form.Group>
            {/* Step 9.0.0 START */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                登録者
              </Col>
              <Col sm={7}>
                <FormControl
                  type="text"
                  name="createdUserName"
                  value={createdUserName}
                  onChange={handleChange}
                  maxLength={40}
                />
              </Col>
            </Form.Group>
            {/* Step 9.0.0 END */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                自サービス/外部
              </Col>
              <Col sm={9} className="padding-top-10" >
                <Form.Check
                  type='radio'
                  className="margin-left-30 padding-top-clear "
                  inline
                  name="dataAffiliationType"
                  id={`dataAffiliationType-${DATA_AFFIILIATION_TYPE.NOT_SELECT}`}
                  onChange={handleChange}
                  value={DATA_AFFIILIATION_TYPE.NOT_SELECT}
                  checked={parseInt(dataAffiliationType, 10) === DATA_AFFIILIATION_TYPE.NOT_SELECT}
                  label='選択なし'></Form.Check>
                <Form.Check
                  type='radio'
                  className="margin-left-30 padding-top-clear"
                  inline
                  name="dataAffiliationType"
                  id={`dataAffiliationType-${DATA_AFFIILIATION_TYPE.INTERNAL}`}
                  value={DATA_AFFIILIATION_TYPE.INTERNAL}
                  onChange={handleChange}
                  checked={parseInt(dataAffiliationType, 10) === DATA_AFFIILIATION_TYPE.INTERNAL}
                  label='自サービスコンテンツ'></Form.Check>
                <Form.Check
                  type='radio'
                  className="margin-left-30 padding-top-clear"
                  inline
                  name="dataAffiliationType"
                  id={`dataAffiliationType-${DATA_AFFIILIATION_TYPE.EXTERNAL}`}
                  value={DATA_AFFIILIATION_TYPE.EXTERNAL}
                  onChange={handleChange}
                  checked={parseInt(dataAffiliationType, 10) === DATA_AFFIILIATION_TYPE.EXTERNAL}
                  label='外部コンテンツ'></Form.Check>
              </Col>
            </Form.Group>
          </Col>
          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="margin-bottom-20">
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
          <Form.Group>
            <Row className="margin-bottom-15">
              <Col sm={9} className="inline-flex">
                {canAccessRegister && (
                  <CustomLink
                    className="margin-right-7 btn-register margin-right-10"
                    to={Path.CONTENT_VIDEO_REGISTER}
                    text="ビデオ追加"
                    icon={ICON.REGIST}
                  />
                )}
                {canAccessImport && (
                  <CustomLink
                    className="margin-right-7 btn-csv-import"
                    to={Path.CONTENT_VIDEO_IMPORT}
                    text="CSV一括投入"
                    icon={ICON.IMPORT}
                  />
                )}
              </Col>
              <Col sm={3}>
                <CustomButton
                  btnStyle="btn btn-export-csv float-end"
                  handleClick={this.props.onExportBtnClick}
                  iconClass="bi bi-download"
                  text="一括出力"
                />
              </Col>
            </Row>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default ContentVideoSearch;
